import React, { Component } from 'react';

class PaymentNote extends Component {
  getOneTimeFee = () => {
    return this.props.oneTimeFee
  }

  getActivationFee = () => {
    return this.props.activationFee
  }

  getAnnualFee = (lessOne = false, initialFee = false) => {
    const { numberOfSports } = this.props
    if (initialFee) {
      return 199
    }

    return lessOne ? 99 * (numberOfSports - 1) : 99 * parseInt(numberOfSports, 10)
  }

  getFirstYearCost = () => {
    let total = this.getOneTimeFee() + this.getAnnualFee(false, true)
    return total
  }

  getAdditionalSportCost = () => {
    return this.getAnnualFee(true)
  }

  calculateLineItemSubtotal = () => {
    return this.getActivationFee() + this.getFirstYearCost() + this.getAdditionalSportCost()
  }

  calculateSubtotal = () => {
    const lineItemSubtotal = this.calculateLineItemSubtotal()
    const discount = this.calculateTotalDiscount()

    return lineItemSubtotal - discount
  }

  calculateTax = () => {
    const { taxRate } = this.props
    return this.calculateSubtotal() * taxRate
  }

  calculateTotalCharge = () => {
    return this.calculateSubtotal() + this.calculateTax()
  }

  calculateTotalDiscount = () => {
    const { coupon } = this.props

    if (coupon) {
      if (coupon.amount_off) {
        return coupon.amount_off / 100
      }

      if (coupon.percent_off) {
        return this.calculateLineItemSubtotal() * (coupon.percent_off / 100)
      }
    }

    return 0
  }

  couponDescription = () => {
    const { coupon } = this.props
    let description = ''

    if (coupon) {
      if (coupon.percent_off) {
        description = coupon.percent_off + '%'
      } else if (coupon.amount_off) {
        description =  '$' + coupon.amount_off / 100
      }
    }

    return description + ' off'
  }

  render() {
    const {
      coupon,
      numberOfSports,
    } = this.props

    return (
      <div className="prices-itemized">
        <div className="prices-itemized-row">
          <div className="description">
            One-Time Fee and First Sport
          </div>
          <div className="price">
            ${this.getFirstYearCost().toFixed(2)}
          </div>
        </div>
        <div className="prices-itemized-row">
          <div className="description">
            Activation Fee
          </div>
          <div className="price">
            ${this.getActivationFee().toFixed(2)}
          </div>
        </div>
        {
          numberOfSports > 1 &&
          <div className="prices-itemized-row">
            <div className="description">
              {numberOfSports - 1} additional sport{numberOfSports - 1 > 1 ? 's' : ''}
            </div>
            <div className="price">
              ${this.getAdditionalSportCost().toFixed(2)}
            </div>
          </div>
        }
        {
          coupon && coupon.valid &&
          <div className="prices-itemized-row">
            <div className="description">
              Coupon Code: {coupon.id} <span className="sub-text">({this.couponDescription()})</span>
            </div>
            <div className="price">
              - ${this.calculateTotalDiscount().toFixed(2)}
            </div>
          </div>
        }
        <div className="prices-itemized-row">
          <div className="description">
            Tax <span className="sub-text">(Based on your billing zip code)</span>
          </div>
          <div className="price">
            ${this.calculateTax().toFixed(2)}
          </div>
        </div>
        <div className="prices-itemized-row-total">
          <div className="description">
            Your card will be charged a total of ${this.calculateTotalCharge().toFixed(2)}*
          </div>
        </div>
      </div>
    )
  }
}

export default PaymentNote;



// WEBPACK FOOTER //
// ./src/components/Payment/PaymentNote.js